<div class="banner">
  <div class="container">
    <h1>{{ 'games.nav.polls' | translate }}</h1>
  </div>
</div>

<div class="container">
  <div class="page-back-button-section" [routerLink]="['/games']">
    <span class="material-icons me-2">navigate_before</span>{{ 'games.back.button.text' | translate }}
  </div>

  <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
    <ng-container *ngIf="pollsQuestions.length > 0; else noGame">
      <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions" (answerSelected)="onAnswerSelected($event)">
      </fgbcl-game-polls-question-list> </ng-container
  ></ng-container>

  <ng-template #noGame>
    <div class="d-flex align-items-center justify-content-center no-game-card">
      {{ 'fgbcl.game.no.item.available.polls.text' | translate }}
    </div>
  </ng-template>

  <!-- Shimmer Effect -->
  <ng-template #shimmerEffect>
    <div class="card bg-primary" aria-hidden="true" *ngFor="let i of [1, 2]">
      <h6 class="card-title placeholder-glow text-center">
        <span class="question-shimmer-effect placeholder col-6"></span>
      </h6>
      <div class="answer-shimmer-effect-section">
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
        </p>
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
        </p>
      </div>

      <div class="d-flex align-items-center justify-content-center">
        <p class="card-text placeholder-glow w-40 text-center">
          <span class="presentby-shimmer-effect placeholder col-7"></span>
        </p>
      </div>
    </div>
  </ng-template>
</div>
